import React, { Component } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Form,
    Label,
    Input,
    Button,
} from "reactstrap";
import config from "../../config/config";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import withRouter from "../../components/Common/withRouter";

class CreateTourExclusion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumbItems: [
                { title: "Tour Exclusion", link: "/tourexclusions" },
                { title: "Create Tour Exclusion", link: "#" },
            ],
            tourExclusionName: "",
        };
    }


    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${config.API_BASE_URL}/tourexclusions`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    tourexclusion_name: this.state.tourExclusionName,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                console.log("Tour exclusions created:", data);
                this.props.router.navigate("/tourexclusions");
            } else {
                console.error("Failed to create tour exclusions:", data);
                alert(data.message || "Failed to create tour exclusions");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Error creating tour exclusions");
        }
    };

    handleCancel = () => {
        this.props.router.navigate("/tourexclusions");
    };

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs
                            title="Create Tour Exclusion"
                            breadcrumbItems={this.state.breadcrumbItems}
                        />
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <Form onSubmit={this.handleSubmit}>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                        <Label className="form-label">Tour Exclusion Name</Label>
                                                        <Input
                                                            type="text"
                                                            name="tourExclusionName"
                                                            placeholder="Enter tour exclusion name"
                                                            value={this.state.tourExclusionName}
                                                            onChange={this.handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row className="mt-4">
                                                <Col className="d-flex justify-content-end">
                                                    <Button type="submit" color="primary" className="me-2">
                                                        Create Tour Exclusion
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        color="secondary"
                                                        onClick={this.handleCancel}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(CreateTourExclusion);
